import { PhotoStore, fileToSquareJPEG, pickImage } from "../lib/photo.js";
import { openStudentModal } from "../components/studentModal.js";
import { personOf } from "../domain/context.js";
import { rerender } from "../lib/rerender.js";
import { state } from "../state.js";

export function bindPhotoEvents(root) {
  const yenile = (kind, id) => {
    rerender();
    if (kind === "student") openStudentModal(id);
  };

  root.querySelectorAll("[data-photo-pick]").forEach(el =>
    el.addEventListener("click", async e => {
      e.stopPropagation();
      const [kind, id] = el.dataset.photoPick.split(":");
      const file = await pickImage();
      if (!file) return;
      state.photoError = null;
      try {
        state.photoDraft = { personId: id, kind, dataUrl: await fileToSquareJPEG(file), consent: false };
      } catch (err) {
        state.photoDraft = null;
        state.photoError = { personId: id, message: err.message };
      }
      yenile(kind, id);
    }));

  root.querySelectorAll("[data-photo-consent]").forEach(el =>
    el.addEventListener("change", () => {
      state.photoDraft.consent = el.checked;
      yenile(state.photoDraft.kind, state.photoDraft.personId);
    }));

  root.querySelectorAll("[data-photo-save]").forEach(el =>
    el.addEventListener("click", async () => {
      const d = state.photoDraft;
      const person = personOf(d.kind, d.personId);

      // Yükleme ağ üzerinden; düğme kilitlenmezse iki kez basılıp
      // aynı dosya iki kez yüklenir ve ikinci denetim kaydı düşer.
      el.disabled = true;
      const uyari = await PhotoStore.save(
        state.branchId, person, d.dataUrl, new Date().toISOString().slice(0, 10),
      );
      state.photoDraft = null;
      state.photoError = uyari ? { personId: d.personId, message: uyari } : null;
      yenile(d.kind, d.personId);
    }));

  root.querySelectorAll("[data-photo-cancel]").forEach(el =>
    el.addEventListener("click", () => {
      const d = state.photoDraft;
      state.photoDraft = null;
      yenile(d.kind, d.personId);
    }));

  root.querySelectorAll("[data-photo-remove]").forEach(el =>
    el.addEventListener("click", async e => {
      e.stopPropagation();
      const [kind, id] = el.dataset.photoRemove.split(":");
      el.disabled = true;
      const uyari = await PhotoStore.remove(state.branchId, personOf(kind, id));
      state.photoError = uyari ? { personId: id, message: uyari } : null;
      yenile(kind, id);
    }));
}
